import { AutogenLayoutAutoRateList } from "./autogen/AutogenLayoutAutoRateList";

export class AutoRateList extends AutogenLayoutAutoRateList {
    onLoad(): void | Promise<void> {
        this.tableRate.addButtonCaption = "Add Auto Rate";
    }
}
